button.hoverFillButton {
	border-width: 2px;
	text-transform: none;
	padding-top: 4px;
	padding-bottom: 4px;
}

button.hoverFillButton.normal {
	color: #42296e;
	border-color: #42296e;
}

button.hoverFillButton.close {
	color: #2e2e2e;
	border-color: #2e2e2e;
}

button.hoverFillButton.delete {
	color: #da2c37;
	border-color: #da2c37;
}

button.hoverFillButton:hover,
button.hoverFillButton:focus-visible {
	border-width: 2px;
}

.hoverFillButton.normal:hover,
.hoverFillButton.normal:focus-visible {
	background-color: #42296e;
	color: white;
}

.hoverFillButton.close:hover,
.hoverFillButton.close:focus-visible {
	background-color: #2e2e2e;
	color: white;
}

.hoverFillButton.delete:hover,
.hoverFillButton.delete:focus-visible {
	background-color: #da2c37;
	color: white;
}

.hoverFillButton svg:global(.MuiSvgIcon-root) {
	font-size: 16px;
}

button.hoverFillButton:disabled {
	background-color: #eaeaea;
	color: #454242;
	border: 2px solid #454242;
}

button.hoverGrowIconButton:hover svg {
	transform: scale(1.1);
}
